import React, { useRef, useEffect, useState } from "react"
import Link from "gatsby-plugin-transition-link"
import cn from "classnames"
import * as s from "./item.module.scss"
import { GatsbyImage } from "gatsby-plugin-image"
import setObserver from "../../utils/setObserver"

type Props = {
  post: {
    slug?: string
    id?: string
    category?: {
      title?: string
    }
    title: string
    targetGroup?: string
    listImage?: {
      gatsbyImageData?: GatsbyImage | GatsbyImage[]
      file?: {
        url?: string
      }
    }
  }
}

const Component: React.FC<Props> = ({ post }) => {
  const [showItem, setShowItem] = useState(false)
  const target = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = setObserver(target.current, "0% 0% -5% 0%", setShowItem)

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <Link
      to={`/casestudy/article/${post.slug || post.id}`}
      entry={{
        length: 1,
      }}
      className={cn(s.link, { [s.show]: showItem })}
      ref={target}
    >
      <div className={s.linkInner}>
        <div className={s.image}>
          {post.listImage?.gatsbyImageData ? (
            <GatsbyImage
              image={post.listImage?.gatsbyImageData}
              objectFit="cover"
              objectPosition="50% 50%"
              alt=""
              className={s.img} />
          ) : (
            <img src={post.listImage?.file?.url} className={s.img} />
          )}
        </div>
        <div className={s.body}>
          <div className={s.meta}>
            {post.category && <p className={s.cate}>{post.category.title}</p>}
          </div>

          <div className={s.text}>
            <p className={s.targetGroup}>{post.targetGroup}</p>
            <h3 className={s.title}>{post.title}</h3>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default Component
